// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const View: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 48"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.5 38.4c-9.9 0-19.2-5.2-24.2-13.7L.9 24l.4-.7c5-8.4 14.2-13.7 24.2-13.7 9.9 0 19.2 5.2 24.2 13.7l.4.7-.4.7c-5 8.4-14.3 13.7-24.2 13.7zM4.1 24c4.6 7.2 12.7 11.6 21.4 11.6S42.3 31.2 46.9 24c-4.6-7.2-12.7-11.6-21.4-11.6S8.7 16.8 4.1 24z"/><path d="M25.5 33.2c-5.2 0-9.4-4.1-9.4-9.2s4.2-9.2 9.4-9.2 9.4 4.1 9.4 9.2-4.2 9.2-9.4 9.2zm0-15.7c-3.7 0-6.6 2.9-6.6 6.5s3 6.5 6.6 6.5c3.7 0 6.6-2.9 6.6-6.5s-2.9-6.5-6.6-6.5z"/></svg>;
};

export default React.memo(View);
